import React, { useEffect } from 'react';
import { Button } from 'semantic-ui-react';

export const TextLink = (props) => {
    let { className } = props;
    const { children, block = false } = props;

    className = className ? `${className} link` : 'link';

    if (block) {
        className += ' block';
    }

    return (
        <Button as="a" {...props} basic className={className}>
            {children}
        </Button>
    );
};
